import React, { useContext } from "react"
import Spinner from "../components/elements/Spinner"
import TextBook, { TextBookKeys } from "../components/Textbook"
import { Context } from "../store/store"
const PromoSoon: React.FC = () => {
	const { globalState } = useContext(Context)

	// useEffect(() => {
	// 	window.scrollTo({
	// 		top: 0,
	// 		left: 0,
	// 		behavior: "smooth",
	// 	})
	// }, [])

	return (
		<>
			{globalState.strapi.homepage ? (
				<>
					<div className="relative before-hero-over">
								<div className="grid md:grid-cols-2 items-center justify-items-center lg:h-[853px] max-w-[1524px] mx-auto">
									<div className="relative sm:hidden bg-[url('/src/bgimages/header-hero-mobile.png')] bg-no-repeat w-full bg-center bg-cover h-[300px] ">
										<img src={process.env.PUBLIC_URL + "/images/hero-mobile-over.png"} alt="TREK Protein Oat Bar" className="mx-auto block sm:hidden" />
									</div>
									<div className="w-full lg:max-w-[100%] mx-auto px-4  pb-12 md:p-12 relative z-[12]">
										<p className="middle bg-[#FFED00] rounded-full py-2 px-3 w-fit mt-0 text-[24px]">GELD ZURÜCK</p>
										<h1 className=" text-white uppercase pt-2 font-AmsiBlack mt-2">Schade – diese Aktion ist bereits beendet.</h1>
										<p className="text-white lg:max-w-[90%] font-AmsiRegular">Vielen Dank für Dein Interesse an der TREK Gratis-Testen-Aktion. Der Aktionszeitraum 
											ist inzwischen abgelaufen. Wir freuen uns, dass du vorbeigeschaut hast, und vielleicht 
											sehen wir uns schon bei der nächsten TREK Aktion wieder. 
											<br/><br/>
											Bis dahin wünschen wir Dir viel Freude mit der natürlichen Energie von TREK.</p>
										<div className=" grid grid-cols-2 md:flex  items-center gap-x-2 md:gap-x-6 mt-6 lg:mt-12 ">
											<a href="https://www.trekbars.com/" className="btn btn-primary justify-self-start" target="_blank" rel="noopener noreferrer">
												Zur Trek Website
											</a>

										</div>
									</div>
									<div className="relative bg-[url('/src/bgimages/bg-hero-right-over.png')] bg-no-repeat w-full bg-center bg-cover h-[300px] md:h-[853px] hidden md:block">
										<img src={process.env.PUBLIC_URL + "/images/trek-biscoff-riegel.png"} alt="TREK Protein Oat Bar Biscoff" className="mx-auto hidden md:block absolute left-12 z-20" />
										<img src={process.env.PUBLIC_URL + "/images/trek-normal-riegel.png"} alt="TREK Protein Oat Bar" className="mx-auto hidden md:block absolute bottom-4 left-12" />
									</div>
								</div>
							</div>
				</>
			) : (
				<div className="py-20 text-center">
					<Spinner />
					<TextBook textKey={TextBookKeys.HOMEPAGE} />
				</div>
			)}
		</>
	)
}
export default PromoSoon
